import { DropdownMenu } from '@octopus-do/octopus-storybook'
import {
  ArrowDown,
  ArrowUp,
  UserFriends,
} from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

interface Props {
  disabledMoveUp: boolean
  disabledMoveDown: boolean
  showAccess: boolean
}

export const FolderMenuContent: React.FC<Props> = ({
  disabledMoveUp,
  disabledMoveDown,
  showAccess,
}) => (
  <>
    <DropdownMenu.Button
      id="move_up"
      title="Move up"
      icon={ArrowUp}
      disabled={disabledMoveUp}
    />
    <DropdownMenu.Button
      id="move_down"
      title="Move down"
      icon={ArrowDown}
      disabled={disabledMoveDown}
    />
    <DropdownMenu.Divider />
    {showAccess && (
      <>
        <DropdownMenu.Button
          id="access"
          title="Visibility"
          icon={UserFriends}
        />
        <DropdownMenu.Divider />
      </>
    )}
    <DropdownMenu.Button id="rename" title="Rename" />
    <DropdownMenu.Button id="delete_folder" title="Delete" danger />
  </>
)
